// import landing from "../../assets/landingImg.jpg";
import PackageTrackingForm from "../../utilcomponents/PackageTrackingForm";
// import { OneData } from "./landingPageConstant";
// import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import heroimage from "../../assets/cargoshipping.jpg";
import heroland from "../../assets/cargoshipping.jpg";
import { BiSolidCheckbox } from "react-icons/bi";

const locations = [
  { name: "America", id: 1 },
  { name: "Europe", id: 2 },
  { name: "N. America", id: 4 },
  { name: "S. America", id: 5 },
];

export default function One() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" }); //1224px
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" });

  if (isTabletOrMobile) {
    console.log("tab or mobile");
  } else if (isDesktopOrLaptop) {
    console.log("desktop or laptop");
  } else if (isBigScreen) {
    console.log("big screen");
  } else if (isPortrait) {
    console.log("portrait");
  } else if (isRetina) {
    console.log("retina");
  }

  const smallScreenContent = (
    <div className="mt-[1rem]     min-h-[39rem] md:min-h-[50rem]     w-[100%]">
      <div className="w-[92%]     mx-auto  flex flex-col justify-center  items-center      gap-[1rem]  md:gap-[2rem]">
        <ul className="mx-auto       flex  justify-center  items-center  gap-[0.5rem]">
          {locations.map((data) => (
            <li
              key={data.id}
              className="custom-blue-text capitalize text-[0.8rem]  md:text-[1.9rem] font-bold"
            >
              <span className="inline-block  text-[1.1rem]  md:text-[1.5rem]  text-red-500">
                &#8226;
              </span>
              {data.name}
            </li>
          ))}
        </ul>
        <p className="    md:w-[80%]  font-poppin  tracking-wide  text-center mx-auto  md:text-[1.3rem]    text-[0.8rem]">
          Whether you're shipping goods by land, sea or air, trust our
          experienced team to handle your logistics needs efficiently and
          reliably. Let's navigate your cargo to its destination
          seamlessly.{" "}
        </p>
      </div>

      <div className="md:my-[2rem]   md:text-[1.1rem]">
        <PackageTrackingForm />{" "}
      </div>
      <ul className="w-[80%]  mx-auto h-[5rem]  hidden       md:w-[90%]  lg:w-[95%]   gap-[1rem]  flex-col   ">
        {/* {OneData.map((data) => (
						<li key={data.id}>
							<Link className="block" to={data.url}>
								<div className="flex  text-white     text-[1.5rem] justify-start items-center gap-[0.5rem]">
									{data.icon}
									<h5 className="text-[1.1rem] text-yellow-500  font-bold">
										{data.title}
									</h5>
								</div>
								<p className="text-gray-300   text-[0.9rem]">{data.subTitle}</p>
							</Link>
						</li>
					))} */}
      </ul>
    </div>
  );

  const bigScreenContent = (
    <div className="     w-[92%]   mx-auto  min-h-full  flex  flex-row-reverse      justify-center  items-start   gap-[7rem]        ">
      <div className=" w-[62%]     min-h-[8rem] text-md    flex justify-start  items-start       ">
        <p className=" min-w-fit     font-poppin      text-left   mx-auto  text-white  bg-black   bg-opacity-25  p-[0.5rem]   tracking-wide ">
          Whether you're shipping goods by land, sea or air, trust our
          experienced team to handle your logistics needs efficiently and
          reliably. Let's navigate your cargo to its destination
          seamlessly.{" "}
        </p>
      </div>
      <div className="  w-full      min-h-[20rem]     flex   flex-col              justify-start  items-start">
        <div className=" w-full  pl-0     grid place-content-start  ">
          <PackageTrackingForm />{" "}
        </div>
        <ul className="mr-auto  mt-[0.8rem]       flex flex-col justify-start  items-start  gap-[0.3rem]">
          {locations.map((data) => (
            <li className="custom-blue-text capitalize text-[1.1rem]  font-black   tracking-wide  ">
              <BiSolidCheckbox className="inline-block  text-[1.1rem]  text-red-700  mr-[0.4rem] " />
              <span className="text-white  tracking-wide"> {data.name}</span>
            </li>
          ))}
        </ul>
        <ul className="w-[80%]  mx-auto h-[5rem]  hidden     md:w-[90%]  lg:w-[95%]   gap-[1rem]  flex-col   ">
          {/* {OneData.map((data) => (
						<li key={data.id}>
							<Link className="block" to={data.url}>
								<div className="flex  text-white     text-[1.5rem] justify-start items-center gap-[0.5rem]">
									{data.icon}
									<h5 className="text-[1.1rem] text-yellow-500  font-bold">
										{data.title}
									</h5>
								</div>
								<p className="text-gray-300   text-[0.9rem]">{data.subTitle}</p>
							</Link>
						</li>
					))} */}
        </ul>
      </div>
    </div>
  );

  const content = (
    <section
      style={{
        backgroundImage: `url(${
          isTabletOrMobile || isPortrait ? heroimage : heroland
        })`,
      }}
      className={` min-h-[10rem]     mx-auto   bg-center bg-cover  bg-no-repeat lg:h-[39rem] xl:h-screen lg:flex lg:justify-center lg:items-center    `}
    >
      <section className="min-w-full   lg:min-h-[17rem]  lg:my-auto   min-h-[32rem]  md:min-h-[60rem]    flex flex-col     gap-[1rem]   justify-center lg:justify-center items-start   ">
        {isTabletOrMobile || isPortrait ? smallScreenContent : bigScreenContent}
      </section>
    </section>
  );

  return content;
}
